import React, { Component } from "react";
import assign from "object-assign";
import update from "immutability-helper";
import { v4 as uuidv4 } from "uuid";

function getInitialId() {
  const id = uuidv4();
  return id;
}

export default function withHistory(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        historyIndex: 0,
        history: [props.initialData],
        showPhotoEditor: false
      };
      // this._id = getInitialId(props.initialData)
      this._id = getInitialId();
    }

    keyDown = (e) => {
      if (e.key === "ArrowLeft") {
        this.undo();
      } else if (e.key === "ArrowRight") {
        this.redo();
      }
    };

    changeLockItem = (item) => {
      const history = this.getPrevHistory();
      let itemIndex,
        isLocked = false;
      history.layers[0].children.forEach((element, index) => {
        if (element.id === item.selectedItem) {
          itemIndex = index;
          isLocked = element.locked;
        }
      });

      const nextHistory = update(history, {
        layers: {
          0: {
            children: { [itemIndex]: { locked: { $set: !isLocked } } }
          }
        }
      });

      this.addHistory(nextHistory);
      return nextHistory;
    };

    changeColorItem = (item, color = "#0088ff") => {
      const history = this.getPrevHistory();
      let itemIndex;
      history.layers[0].children.forEach((element, index) => {
        if (element.id === item.selectedItem) {
          itemIndex = index;
        }
      });

      const nextHistory = update(history, {
        layers: {
          0: {
            children: { [itemIndex]: { strokeColor: { $set: color } } }
          }
        }
      });

      this.addHistory(nextHistory);
    };

    groupItems = (items) => {
      let hasGroup = false;
      const history = this.getPrevHistory();
      history.layers[0].groups.forEach((group) => {
        items.forEach((item) => {
          if (group.children.includes(item)) {
            hasGroup = true;
          }
        });
      });
      if (!hasGroup) {
        const nextGroup = {
          name: "Group",
          id: uuidv4(),
          children: items
        };
        const nextHistory = update(history, {
          layers: {
            0: { groups: { $push: [nextGroup] } }
          }
        });
        this.addHistory(nextHistory);
        return nextGroup;
      }
      return null;
    };

    addItem = (layer, data) => {
      const history = this.getPrevHistory();
      const layerIndex = history.layers.findIndex(
        (l) => l.id === layer.data.id
      ) < 0 ? 0 : -1;
      const nextItem = assign(data, { id: uuidv4() });

      const nextHistory = update(history, {
        layers: layers =>
          update(layers || [], {
            [layerIndex]: layer =>
              update(layer || {}, {
                children: children => update(children || [], { $push: [nextItem] }),
                id: id => update(id || '', {$set: layerIndex}),
                type: type => update(type || '', {$set: 'Layer'}),
                name: name => update(name || '', {$set: 'Masir Test'}),
              }),
          })
      });

      this.addHistory(nextHistory);
      return nextItem;
    };

    updateItem = (item, data) => {
      const history = this.getPrevHistory();
      let layerIndex = history.layers.findIndex(
        (l) => l.id === item.layer.data.id
      );

      if(layerIndex == -1) layerIndex = 0
      const children = history.layers[layerIndex].children;
      const itemIndex = children.findIndex((i) => i.id === item.data.id);
      const nextItem = assign({}, children[itemIndex], data);
      const nextHistory = update(history, {
        layers: {
          [layerIndex]: { children: { [itemIndex]: { $set: nextItem } } }
        }
      });

      this.addHistory(nextHistory);
      return nextItem;
    };

    updateItemById = (id, layerIndex, data) => {
      const history = this.getPrevHistory();
      const children = history.layers[layerIndex].children;
      const itemIndex = children.findIndex((i) => i.id === id);
      const nextItem = assign({}, children[itemIndex], data);
      const nextHistory = update(history, {
        layers: {
          [layerIndex]: { children: { [itemIndex]: { $set: nextItem } } }
        }
      });
      this.addHistory(nextHistory);
   
      return nextItem;
    };

    removeItem = (item) => {
      const history = this.getPrevHistory();
      let layerIndex = history.layers.findIndex(
        (l) => l.id === item.layer.data.id
      );
      if(layerIndex < 0) layerIndex = 0
      const children = history.layers[layerIndex].children;
      const itemIndex = children.findIndex((i) => i.id === item.data.id);
      const nextHistory = update(history, {
        layers: {
          [layerIndex]: { children: { $splice: [[itemIndex, 1]] } }
        }
      });
      this.addHistory(nextHistory);
    };

    addHistory = (nextHistory) => {
      const historyIndex = this.state.historyIndex + 1;
      const history = [
        ...this.state.history.slice(0, historyIndex),
        nextHistory
      ];
      this.setState({ historyIndex, history });
    };

    getPrevHistory = () => {
      return this.state.history[this.state.historyIndex];
    };

    clearHistory = () => {
      this.setState({
        historyIndex: 0,
        history: [this.props.initialData]
      });
    };

    undo = () => {
      const { historyIndex, history } = this.state;
      if (historyIndex <= 0) {
        return;
      }
      this.setState({
        historyIndex: historyIndex - 1,
        items: history[historyIndex]
      });
    };

    redo = () => {
      const { historyIndex, history } = this.state;
      if (historyIndex >= history.length - 1) {
        return;
      }
      this.setState({
        historyIndex: historyIndex + 1,
        items: history[historyIndex + 1]
      });
    };

    photoEditorHandler = () => {
      this.setState({ showPhotoEditor: !this.state.showPhotoEditor });
    };

    componentDidMount() {
      document.addEventListener("keydown", this.keyDown);
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.keyDown);
    }

    render() {
      const { historyIndex, history } = this.state;
      return (
        <WrappedComponent
          {...this.props}
          data={history[historyIndex]}
          addItem={this.addItem}
          groupItems={this.groupItems}
          changeColorItem={this.changeColorItem}
          changeLockItem={this.changeLockItem}
          removeItem={this.removeItem}
          updateItem={this.updateItem}
          updateItemById={this.updateItemById}
          canUndo={historyIndex > 0}
          canRedo={history.length > 1 && historyIndex + 1 < history.length}
          showPhotoEditor={this.state.showPhotoEditor}
          photoEditorHandler={this.photoEditorHandler}
          undo={this.undo}
          redo={this.redo}
          clearHistory={this.clearHistory}
        />
      );
    }
  };
}
